/**
 * @namespace toolkit.enums
 */
 
 /**
 * @class toolkit.enums.ManagerState
 * @classdesc States for manager.
 */
export enum ManagerState {

    /**
     * Shows the lookup grid.
     * @member {number} toolkit.enums.ManagerState#Lookup
     */  
    Lookup = 0,

    /**
     * Shows the editor.
     * @member {number} toolkit.enums.ManagerState#Editor
     */  
    Editor = 1
}



// WEBPACK FOOTER //
// ./src/enums/managerState.ts